import { TouchableOpacity, View } from 'react-native'
import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { BtApiTable, BtText } from '@linqpal/components/src/ui'
import { StyleSheet } from 'react-native'
import { routes2 } from '@linqpal/models'
import { useSearchInput } from '../../../../utils/hooks'
import { colors } from '../../../../../../components/src/theme'
import { SearchField } from '../../../Projects/Desktop/Components/ProjectsTable/SearchField'
import { ProjectsEmptyContent } from '../../../Projects/Desktop/Components/ProjectsEmptyContent'
import projectsStore from '../../../Projects/Store'

type Props = {
  onProjectSelect: (project: any) => void
}

export const ProjectsTable: React.FC<Props> = observer(
  ({ onProjectSelect }) => {
    const { t } = useTranslation('global')
    const { searchText, setSearchText } = useSearchInput()
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
    const { count, pageSize, refresher } = projectsStore

    const getAddress = ({ streetAddress, city, state, zip }) => {
      return `${streetAddress}, ${city}, ${state}, ${zip}`
    }

    const col = [
      {
        cell: (item: any) => (
          <View
            style={{
              flexDirection: 'row',
              marginBottom: 20,
              marginTop: 20,
              width: '100%',
            }}
            testID={'projects-table-cell-container'}
          >
            <View style={{ flex: 1 }}>
              <BtText style={styles.rowsLabel}>
                {item.data
                  ? getAddress(item.data?.propertyAddress.items[0].content)
                  : item.address}
              </BtText>
            </View>
            <TouchableOpacity
              style={{
                width: 126,
                height: 34,
                borderRadius: 8,
                backgroundColor: '#F5F7F8',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <BtText
                style={{ fontWeight: '700', fontSize: 14 }}
                onPress={() => {
                  onProjectSelect(item)
                }}
              >
                {`Select`}
              </BtText>
            </TouchableOpacity>
          </View>
        ),
      },
    ]
    return (
      <View style={styles.mainWrapper} testID={'projects-table-wrapper'}>
        <BtApiTable
          style={customStyles}
          columns={col}
          apiCaller={(args) => routes2.project.findAll(args)}
          filterPlaceholder={t('Projects.searchPropertyAddress' as any)}
          defaultSortColumn={t('Projects.createdAt' as any)}
          refresher={refresher}
          noDataComponent={
            <ProjectsEmptyContent
              title={t('noItems')}
              subtitle={t('Projects.TryAgainProject')}
              btnText={t('Projects.create-project')}
            />
          }
          pagination
          paginationServer
          rowsPerPage={pageSize}
          paginationTotalRows={count}
          paginationPerPage={5}
          filterWidth={'100%'}
          subHeader
          subHeaderAlign={t('Projects.left' as any)}
          highlightOnHover={false}
          subHeaderComponent={
            <SearchField
              value={searchText}
              onChange={setSearchText}
              setResetPaginationToggle={setResetPaginationToggle}
              resetPaginationToggle={resetPaginationToggle}
            />
          }
        />
      </View>
    )
  },
)

const styles = StyleSheet.create({
  mainWrapper: { flex: 1 },
  inputContainer: {
    width: 542,
    paddingLeft: 16,
    paddingRight: 19,
    backgroundColor: '#F7F9FC',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E4E9F2',
    textAlignVertical: 'top',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 31,
    marginLeft: -24,
  },
  input: {
    // width: 680,
    marginTop: 0,
    backgroundColor: '#F7F9FC',
    borderWidth: 1,
    borderColor: '#E4E9F2',
  },
  rowsLabel: {
    fontWeight: '500',
    fontSize: 14,
    color: '#003353',
    lineHeight: 20,
  },
  businessNameLabel: {
    fontSize: 16,
    color: '#335C75',
    lineHeight: 24,
  },
})

const customStyles = {
  table: {
    style: { backgroundColor: colors.surface, alignSelf: 'center' },
  },
  tableWrapper: {
    style: {
      backgroundColor: colors.surface,
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
    },
  },
  subHeader: {
    style: {
      paddingBottom: 0,
      flex: 1,
    },
  },
  head: {
    style: {},
  },
  headRow: {
    style: {
      borderBottomWidth: 0,
      minHeight: 35,
    },
    denseStyle: {},
  },
  contextMenu: {
    style: {},
    activeStyle: {},
  },
  cells: {
    style: {
      paddingLeft: 0,
      paddingRight: 0,
      color: colors.primary,
      fontSize: 16,
      lineHeight: 1.5,
      fontWeight: '400',
    },
  },
  rows: {
    selectedHighlightStyle: {},
    denseStyle: {},
    stripedStyle: {},
  },
  expanderRow: {
    style: {},
  },
  expanderCell: {
    style: {},
  },
  expanderButton: {
    style: {},
  },
  pagination: {
    style: {
      width: '90%',
      alignSelf: 'center',
      borderTopWidth: 0,
    },
    pageButtonsStyle: {},
  },
  noData: {
    style: {},
  },
  progress: {
    style: { width: '100%' },
  },
}
